import { Fragment, useContext } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import FloatingChatButton from '../../../components/FloatingChatButton'
import { BreadcrumbContext } from '../../../contexts/BreadcrumbContext'
import { GatewayDevice } from '../../../lib/types'
import { devCustomerScalling, isScaling } from '../../../lib/utils'
import { useSessionContex } from '../../../SessionContex'
import DropDown from '../DropDown'
import GlobalSearchInput from '../global-search-bar'
import GroupSettingBtn from '../GroupSettingBtn/GroupSettingBtn'
import LogOutBtn from '../Logout'
import NotificationIconButton from '../NotificationIcon/NotificationIconButton'
import ReloadBtn from '../ReloadBtn'

const RightSideBar = ({ gatewayInfo }: { gatewayInfo?: GatewayDevice }) => {
  const { filters = [], disabled = true }: any = useContext(BreadcrumbContext)
  const { email } = useParams()
  const location = useLocation()
  const { reCall, setReCall, setCSReCall, csReCall, fullLoading } = useSessionContex()

  return (
    <div className='rightSideBar-wrapper flex justify-end items-center gap-2' key={1}>
      {!email &&
        location.search === '' &&
        !location.pathname.includes('/Agent') &&
        !location.pathname.includes('/groups') &&
        !location.pathname.includes('/batch') &&
        !location.pathname.includes('/reports') &&
        !location.pathname.includes('/maps') &&
        !location.pathname.includes('/legacy') &&
        !location.pathname.includes('/notifications') &&
        filters?.map((item: any, index: number) => {
          return (
            <Fragment key={index}>
              <DropDown
                disable={disabled}
                key={index}
                maxWidth={'210px'}
                options={item.options}
                label={item.label}
                tags={item?.tags}
                filterKey={item.filterKey}
                onClick={item.action}
                activeOption={item?.activeOption}
                preventActive={item?.preventActive}
              />
            </Fragment>
          )
        })}

      {!location.pathname.includes('/reports') && !location.pathname.includes('/maps') && (
        <ReloadBtn
          setReCall={location.state === 'service' && location.search === '' ? setCSReCall : setReCall}
          reCall={location.state === 'service' && location.search === '' ? csReCall : reCall}
          fullLoading={fullLoading}
        />
      )}
      {!location.pathname.includes('/Agent') &&
        !location.pathname.includes('/groups') &&
        !location.pathname.includes('/batch') &&
        !location.pathname.includes('/reports') &&
        !location.pathname.includes('/maps') &&
        !location.pathname.includes('/legacy') &&
        !location.pathname.includes('/notifications') && <GlobalSearchInput />}

      {!location.pathname.includes('/Agent') &&
        !location.pathname.includes('/groups') &&
        !location.pathname.includes('/batch') &&
        !location.pathname.includes('/reports') &&
        !location.pathname.includes('/maps') &&
        !location.pathname.includes('/legacy') &&
        devCustomerScalling &&
        gatewayInfo?.is_online &&
        gatewayInfo?.dev_mesh_role === 'CAP' && <FloatingChatButton />}

      {!location.pathname.includes('/legacy') && <GroupSettingBtn />}
      {isScaling && <NotificationIconButton />}
      <LogOutBtn />
    </div>
  )
}

export default RightSideBar
